export const DBNP_PRODUCTS_RESET_STATE = 'DBNP_PRODUCTS_RESET_STATE';
export const DBNP_PRODUCTS_CURRENT_ITEM = 'DBNP_PRODUCTS_CURRENT_ITEM';

export const DBNP_PRODUCTS_REQUEST_LOADING = 'DBNP_PRODUCTS_REQUEST_LOADING';
export const DBNP_PRODUCTS_REQUEST_SUCCESS = 'DBNP_PRODUCTS_REQUEST_SUCCESS';
export const DBNP_PRODUCTS_REQUEST_FAILED = 'DBNP_PRODUCTS_REQUEST_FAILED';

export const DBNP_PRODUCTS_CURRENT_ACTION = 'DBNP_PRODUCTS_CURRENT_ACTION';
export const DBNP_PRODUCTS_RESET_ACTION = 'DBNP_PRODUCTS_RESET_ACTION';